import { HomeIcon, NotFoundIcon } from "@/shared/presentation/components/icons";
import { Button, Center, Container, Flex, Text } from "@reverb-ui/react";
import React from "react";
import { Link } from "react-router-dom";
var NotFoundContainer = function () { return (React.createElement(Container, { maxW: "xl", centerContent: true, "data-testid": "not-found-component" },
    React.createElement(Center, { mt: "10%" },
        React.createElement(Flex, { h: "100%", flexDirection: "column", align: "center", justifyContent: "space-evenly" },
            React.createElement(NotFoundIcon, null),
            React.createElement(Text, { m: "4", fontWeight: "bold" }, "Page not found"),
            React.createElement(Link, { to: "/" },
                React.createElement(Button, { leftIcon: React.createElement(HomeIcon, null), colorScheme: "blue", bg: "blue.500" }, "Go to home screen")))))); };
export default NotFoundContainer;
